module.exports = __webpack_public_path__ + "img/api-economy-community.df767c00.svg";